export default "__VITE_ASSET__CqW6zyvk__"